import { BackgroundToggle } from "@/components/ui/background-toggle";
import { Button } from "@/components/ui/button";
import { ModeToggle } from "@/components/ui/mode-toggle";
import { RadiusToggle } from "@/components/ui/radius-toggle";
import { ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 text-center">
      <h1 className="text-6xl font-bold">
        404
      </h1>
      <h2 className="mt-4 text-2xl font-semibold">
        Page Not Found
      </h2>
      <p className="mt-2 text-muted-foreground">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="mt-8 flex items-center gap-2">
        <Button onClick={() => navigate(-1)} variant="outline">
          <ArrowLeft className="group-hover:-translate-x-0.5 transition-all" />
          Go Back
        </Button>
        <Button onClick={() => navigate("/")} variant="default">
          <Home className="group-hover:-rotate-12 transition-all group-active:rotate-12"/>
          Go Home
        </Button>
      </div>
      <div className="mt-8 flex items-center gap-2">
        <RadiusToggle />
        <ModeToggle />
        <BackgroundToggle />
      </div>
    </div>
  );
};

export default NotFound;
